exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".probe-choice[data-v-380286c3] {\n  font-size: 0.5rem;\n  line-height: 0.6rem;\n  padding: 0.2rem 0.3rem;\n}\n.line[data-v-380286c3]:first-child {\n  border: solid 1px #8f8f8f;\n}\n.line[data-v-380286c3] {\n  border: solid 1px #8f8f8f;\n  border-top: none;\n}\ndiv.flagged[data-v-380286c3] {\n  background-color: #fcf8ed;\n}\nsmall.flagged[data-v-380286c3] {\n  color: #ff0000;\n  font-weight: 600;\n}\n.tracker-row[data-v-380286c3]:hover {\n  background: #ffe6ec;\n}", ""]);

// exports
